import { ArrowRight, Sparkles } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative pt-32 md:pt-36 pb-20 md:pb-28 overflow-hidden grain"
    >
      {/* Decorative blobs */}
      <div className="absolute -top-24 -left-32 w-[420px] h-[420px] rounded-full bg-lilac/30 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 right-[-120px] w-[480px] h-[480px] rounded-full bg-blush/30 blur-3xl pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <div
            className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/60 backdrop-blur border border-charcoal/10 mb-7"
            data-testid="hero-badge"
          >
            <Sparkles size={14} className="text-lilac" />
            <span className="eyebrow !tracking-[0.22em] !text-[0.68rem]">
              A Women-Led Digital Agency
            </span>
          </div>

          <h1
            className="font-display text-charcoal text-5xl sm:text-6xl lg:text-[5.5rem] leading-[1.02] tracking-tight"
            data-testid="hero-headline"
          >
            Content that{" "}
            <span className="italic text-lilac">means</span>{" "}
            business.
          </h1>

          <p
            className="font-body mt-7 text-charcoal/75 text-base md:text-lg max-w-xl leading-relaxed"
            data-testid="hero-subheadline"
          >
            We simplify social media for businesses — helping them grow with
            confidence through authentic, creative content and results-driven
            strategies that turn attention into real, sustainable business
            impact.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a href="#services" className="btn-primary" data-testid="hero-services-button">
              Explore Services <ArrowRight size={16} />
            </a>
            <a href="#contact" className="btn-ghost" data-testid="hero-contact-button">
              Book a Discovery Call
            </a>
          </div>

          {/* Stat strip */}
          <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg">
            {[
              { k: "15+", v: "Brands Grown" },
              { k: "5K+", v: "Impressions Driven" },
              { k: "5★", v: "Avg. Client Rating" },
            ].map((s) => (
              <div key={s.v} data-testid={`hero-stat-${s.v.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="font-display text-3xl md:text-4xl text-charcoal">
                  {s.k}
                </div>
                <div className="mt-1 text-xs uppercase tracking-[0.2em] text-charcoal/55">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Visual */}
        <div className="lg:col-span-5 relative">
          <div className="relative rounded-[28px] overflow-hidden border border-charcoal/10 shadow-[0_50px_100px_-60px_rgba(62,54,51,0.55)]">
            <img
              src={`${process.env.PUBLIC_URL}/img/hero.jpeg`}
              alt="Creative team collaborating in studio"
              className="w-full h-[560px] object-cover"
              style={{
                filter:
                  "grayscale(0.55) sepia(0.35) hue-rotate(280deg) saturate(0.85) brightness(0.95)",
              }}
              data-testid="hero-image-main"
            />
            {/* brand-tinted duotone wash to harmonize with pearl/blush/lilac palette */}
            <div className="absolute inset-0 bg-gradient-to-br from-lilac/30 via-transparent to-charcoal/45 mix-blend-multiply" />
            <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 via-charcoal/10 to-transparent" />

            <div
              className="absolute bottom-6 left-6 right-6 flex items-center justify-between rounded-2xl px-5 py-4 border border-charcoal/10 shadow-lg z-10"
              style={{ backgroundColor: "#F5F3ED" }}
            >
              <div>
                <div className="text-[0.68rem] uppercase tracking-[0.24em] text-charcoal/60">
                  Featured
                </div>
                <div className="font-display text-lg text-charcoal mt-0.5">
                  Brands 100% Instagram Growth
                </div>
              </div>
              {/* <div className="w-10 h-10 rounded-full bg-blush flex items-center justify-center text-white">
                <ArrowRight size={18} />
              </div> */}
            </div>
          </div>

          {/* Floating chip */}
          {/* <div className="hidden md:flex items-center gap-3 absolute -left-10 top-10 bg-white border border-charcoal/10 rounded-full px-4 py-3 shadow-lg">
            <span className="w-2.5 h-2.5 rounded-full bg-lilac inline-block" />
            <span className="text-sm font-semibold text-charcoal">
              Now Booking · Q1 Slots
            </span>
          </div> */}
        </div>
      </div>

      {/* Marquee */}
      <div className="relative mt-20 border-y border-charcoal/10 bg-pearl/60 overflow-hidden">
        <div className="flex gap-16 py-5 whitespace-nowrap animate-marquee">
          {[
            "Strategy",
            "Storytelling",
            "Reels",
            "Brand Identity",
            "SEO",
            "Performance",
            "Email",
            "Influencer",
            "Strategy",
            "Storytelling",
            "Reels",
            "Brand Identity",
            "SEO",
            "Performance",
            "Email",
            "Influencer",
          ].map((w, i) => (
            <span
              key={i}
              className="font-display text-2xl md:text-3xl text-charcoal/50 italic"
            >
              {w} <span className="text-lilac mx-2">✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
